import {
  faClock,
  faCode,
  faExchangeAlt,
  faFileCode,
  faFingerprint,
  faHashtag,
  faKey,
  faLink,
  faMagnifyingGlass,
  faShieldHalved,
  faToolbox,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * Slug -> glyph, kept out of tools.json on purpose: that file is parsed by the
 * Node prerender step, which must stay free of Font Awesome imports. Anything
 * rendering a tool card (the homepage, the tools index, the navbar menu) reads
 * its icon from here.
 */
const TOOL_ICONS: Record<string, IconDefinition> = {
  home: faKey,
  base64: faCode,
  'url-encoding': faLink,
  'xml-encoding': faFileCode,
  'json-yaml': faExchangeAlt,
  hash: faHashtag,
  jwt: faShieldHalved,
  uuid: faFingerprint,
  timestamp: faClock,
  regex: faMagnifyingGlass,
  tools: faToolbox,
};

/** The glyph for a route, falling back to the generic toolbox for a new slug. */
export function toolIcon(slug: string): IconDefinition {
  return TOOL_ICONS[slug] ?? faToolbox;
}

export default TOOL_ICONS;
